import { LockKeyhole } from "lucide-react";
import { useState } from "react";

import Button from "./Button.jsx";
import SectionHeader from "./SectionHeader.jsx";

const TOKEN_KEY = "ccs_admin_token";
const EMAIL_KEY = "ccs_admin_email";

export default function Login({ navigate }) {
  const [email, setEmail] = useState(() => localStorage.getItem(EMAIL_KEY) || "");
  const [secretKey, setSecretKey] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();

    setError("");
    setLoading(true);

    try {
      const response = await fetch("/api/admin/login", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({ email, secretKey }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Login failed.");
        return;
      }

      localStorage.setItem(TOKEN_KEY, data.token);
      localStorage.setItem(EMAIL_KEY, data.email);
      navigate("/admin");
    } catch (err) {
      setError("Unable to reach the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mx-auto max-w-xl px-4 py-14 sm:px-6 lg:px-8">
      <SectionHeader
        eyebrow="Staff Access"
        title="Admin Sign In"
      >
        Use your approved admin email and private secret key.
      </SectionHeader>

      <form
        onSubmit={onSubmit}
        className="mt-8 rounded-md border border-civic-line bg-white p-6 shadow-sm"
      >
        <div className="mb-5 flex items-center gap-3">
          <LockKeyhole
            className="h-6 w-6 text-civic-blue"
            aria-hidden="true"
          />

          <div>
            <div className="font-bold text-civic-navy">
              Admin verification
            </div>

            <div className="text-sm text-slate-500">
              Admin access is limited by email and secret key.
            </div>
          </div>
        </div>

        <label className="label" htmlFor="admin-email">
          Admin email
        </label>

        <input
          id="admin-email"
          type="email"
          className="field"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          autoComplete="email"
          required
        />

        <label className="label mt-4" htmlFor="admin-secret-key">
          Secret key
        </label>

        <input
          id="admin-secret-key"
          type="password"
          className="field"
          value={secretKey}
          onChange={(event) => setSecretKey(event.target.value)}
          autoComplete="current-password"
          required
        />

        {error && (
          <div
            className="mt-4 rounded-md bg-red-50 p-3 text-sm font-semibold text-signal-red"
            role="alert"
          >
            {error}
          </div>
        )}

        <Button
          type="submit"
          disabled={loading}
          className="mt-5 w-full"
        >
          {loading ? "Signing in..." : "Sign in"}
        </Button>
      </form>
    </section>
  );
}
